import { IdAccumulators } from './duplicateIdsSearchEngine'

export const createDuplicateIdsSearchAccumulators = (): IdAccumulators => {
  return {
    duplicateIds: new Set(),
    encounteredIds: new Set()
  }
}
